"use client"

import { CalendarPlus2 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CalendarPlus2Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CalendarPlus2Icon = component(Icon)({ as: CalendarPlus2 })
